import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import ObjectType from '../models/ObjectType';
import Urls from './../api/Urls';

export function getObjectType(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_LIST,
        params: params,
        parser: objectTypesDataParser,
    }).get();
}

export function getAllObjectType(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_ALL,
        params: params,
        parser: data => (data.data || []).map(item => new ObjectType(item)),
    }).get();
}

export function getObjectTypeDetail(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_DETAIL,
        endpointParams: { id },
        parser: (data) => new ObjectType(data.data),
    }).get();
}

export function createObjectTypeDetail(objectType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_ACTION,
        parser: (data) => new ObjectType(data.objectType),
    }).post(objectType.export());
}

export function updateObjectTypeDetail(objectType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_ACTION,
        parser: (data) => new ObjectType(data.objectType),
    }).put(objectType.export());
}

export function deleteObjectTypeDetail(objectType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_DETAIL,
        endpointParams: { id: objectType.id }
    }).delete();
}

export function createObjectTypeTranslate(objectType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_TRANSLATE_CREATE,
    }).post(objectType.export(true).translate());
}

export function updateObjectTypeTranslate(objectType) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_TRANSLATE_UPDATE,
    }).put(objectType.export(true).translate());
}

export function deleteObjectTypeTranslate(id) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.OBJECT_TYPE_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

const objectTypesDataParser = (data) => ({
    result: (data.data.result || []).map(item => new ObjectType(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})